import { PublishedFormId } from '@furnish-hx/constants/FormId';
import FormTypeId from '@core/constants/FormTypeId';
import fieldPortfolioData from './common/fieldsPortfolioData';
import {
    IFormFieldKey,
    IForm,
} from '../../interfaces/Form';
import fieldsContact from './common/fieldsContact';
import { IDesignProjectId, IDesignProjectCategoryId } from '../../interfaces/DesignProject';
import additionalDataFactory from './common/fieldsAdditionalData';
import budgetMarksBuilder from './common/budgetMarksBuilder';

const dpHouseInteriorForm: IForm = {
    formId       : PublishedFormId.DpHouseInterior,
    type         : FormTypeId.DesignProject,
    thumbnailURL : '/resized-images/forms/dpHouseInterior.jpg',
    fieldsOrder  : [
        IFormFieldKey.PortfolioData,
        IFormFieldKey.Comment,
        IFormFieldKey.DesignProject,
        IFormFieldKey.AdditionalData,
        IFormFieldKey.Contact,
    ],
    fields: {
        portfolioData : fieldPortfolioData,
        comment       : {
            comment: {
                value    : undefined,
                required : false,
            },
        },
        designProject: {
            [IDesignProjectCategoryId.LivingRoom]: {
                [IDesignProjectId.CompleteStaircase]: {
                    value : undefined,
                    min   : 0,
                    max   : 2,
                },
                [IDesignProjectId.StairRailing]: {
                    value : undefined,
                    min   : 0,
                    max   : 2,
                },
                [IDesignProjectId.Stairs]: {
                    value : undefined,
                    min   : 0,
                    max   : 50,
                },
                [IDesignProjectId.DinnerTable]: {
                    value : undefined,
                    min   : 0,
                    max   : 5,
                },
                [IDesignProjectId.LowTable]: {
                    value : undefined,
                    min   : 0,
                    max   : 5,
                },
                [IDesignProjectId.TvUnit]: {
                    value : undefined,
                    min   : 0,
                    max   : 5,
                },
                [IDesignProjectId.Buffet]: {
                    value : undefined,
                    min   : 0,
                    max   : 5,
                },
                [IDesignProjectId.Console]: {
                    value : undefined,
                    min   : 0,
                    max   : 5,
                },
                [IDesignProjectId.Library]: {
                    value : undefined,
                    min   : 0,
                    max   : 5,
                },
                [IDesignProjectId.Dresser]: {
                    value : undefined,
                    min   : 0,
                    max   : 5,
                },
                [IDesignProjectId.ShoesCabinet]: {
                    value : undefined,
                    min   : 0,
                    max   : 5,
                },
                [IDesignProjectId.Cupboard]: {
                    value : undefined,
                    min   : 0,
                    max   : 5,
                },
                [IDesignProjectId.Door]: {
                    value : undefined,
                    min   : 0,
                    max   : 5,
                },
                [IDesignProjectId.Chair]: {
                    value : undefined,
                    min   : 0,
                    max   : 10,
                },
                [IDesignProjectId.Armchair]: {
                    value : undefined,
                    min   : 0,
                    max   : 5,
                },
                [IDesignProjectId.Sofa]: {
                    value : undefined,
                    min   : 0,
                    max   : 5,
                },
                [IDesignProjectId.TiledFloorHouseInterior]: {
                    value : undefined,
                    min   : 0,
                    max   : 100,
                },
                [IDesignProjectId.WaxedConcreteFloorHouseInterior]: {
                    value : undefined,
                    min   : 0,
                    max   : 100,
                },
                [IDesignProjectId.ParquetFloorHouseInterior]: {
                    value : undefined,
                    min   : 0,
                    max   : 100,
                },
            },
            [IDesignProjectCategoryId.Kitchen]: {
                [IDesignProjectId.DinnerTable]: {
                    value : undefined,
                    min   : 0,
                    max   : 5,
                },
                [IDesignProjectId.HighTable]: {
                    value : undefined,
                    min   : 0,
                    max   : 5,
                },
                [IDesignProjectId.EatStandingUp]: {
                    value : undefined,
                    min   : 0,
                    max   : 5,
                },
                [IDesignProjectId.WorkTop]: {
                    value : undefined,
                    min   : 0,
                    max   : 5,
                },
                [IDesignProjectId.Equippedkitchen]: {
                    value : undefined,
                    min   : 0,
                    max   : 2,
                },
                [IDesignProjectId.Chair]: {
                    value : undefined,
                    min   : 0,
                    max   : 20,
                },
                [IDesignProjectId.BarChair]: {
                    value : undefined,
                    min   : 0,
                    max   : 10,
                },
                [IDesignProjectId.Stool]: {
                    value : undefined,
                    min   : 0,
                    max   : 20,
                },
                [IDesignProjectId.Bench]: {
                    value : undefined,
                    min   : 0,
                    max   : 10,
                },
                [IDesignProjectId.Armchair]: {
                    value : undefined,
                    min   : 0,
                    max   : 10,
                },
                [IDesignProjectId.Cupboard]: {
                    value : undefined,
                    min   : 0,
                    max   : 5,
                },
                [IDesignProjectId.WoodenWardrobe]: {
                    value : undefined,
                    min   : 0,
                    max   : 5,
                },
                [IDesignProjectId.MetalicWardrobe]: {
                    value : undefined,
                    min   : 0,
                    max   : 5,
                },
                [IDesignProjectId.Bind]: {
                    value : undefined,
                    min   : 0,
                    max   : 5,
                },
                [IDesignProjectId.TiledFloorKitchen]: {
                    value : undefined,
                    min   : 0,
                    max   : 100,
                },
                [IDesignProjectId.WaxedConcreteFloorKitchen]: {
                    value : undefined,
                    min   : 0,
                    max   : 100,
                },
                [IDesignProjectId.ParquetFloorKitchen]: {
                    value : undefined,
                    min   : 0,
                    max   : 100,
                },
                [IDesignProjectId.PartitionSeparation]: {
                    value : undefined,
                    min   : 0,
                    max   : 5,
                },
                [IDesignProjectId.GlassWall]: {
                    value : undefined,
                    min   : 0,
                    max   : 2,
                },
            },
            [IDesignProjectCategoryId.BathRoom]: {
                [IDesignProjectId.StorageUnit]: {
                    value : undefined,
                    min   : 0,
                    max   : 5,
                },
                [IDesignProjectId.VanityUnit]: {
                    value : undefined,
                    min   : 0,
                    max   : 5,
                },
                [IDesignProjectId.GlassShowerScreen]: {
                    value : undefined,
                    min   : 0,
                    max   : 5,
                },
                [IDesignProjectId.Mirror]: {
                    value : undefined,
                    min   : 0,
                    max   : 5,
                },
                [IDesignProjectId.TiledFloorBathRoom]: {
                    value : undefined,
                    min   : 0,
                    max   : 100,
                },
                [IDesignProjectId.WaxedConcreteFloorBathRoom]: {
                    value : undefined,
                    min   : 0,
                    max   : 100,
                },
                [IDesignProjectId.ParquetFloorBathRoom]: {
                    value : undefined,
                    min   : 0,
                    max   : 100,
                },
                [IDesignProjectId.GlassWall]: {
                    value : undefined,
                    min   : 0,
                    max   : 5,
                },
            },
            [IDesignProjectCategoryId.BedRoom]: {
                [IDesignProjectId.DressingRoom]: {
                    value : undefined,
                    min   : 0,
                    max   : 5,
                },
                [IDesignProjectId.Wardrobe]: {
                    value : undefined,
                    min   : 0,
                    max   : 5,
                },
                [IDesignProjectId.Bedding]: {
                    value : undefined,
                    min   : 0,
                    max   : 5,
                },
                [IDesignProjectId.Bedhead]: {
                    value : undefined,
                    min   : 0,
                    max   : 5,
                },
                [IDesignProjectId.Bedspring]: {
                    value : undefined,
                    min   : 0,
                    max   : 5,
                },
                [IDesignProjectId.Library]: {
                    value : undefined,
                    min   : 0,
                    max   : 5,
                },
                [IDesignProjectId.ArmorWardrobe]: {
                    value : undefined,
                    min   : 0,
                    max   : 5,
                },
                [IDesignProjectId.Dresser]: {
                    value : undefined,
                    min   : 0,
                    max   : 5,
                },
                [IDesignProjectId.GlassWall]: {
                    value : undefined,
                    min   : 0,
                    max   : 2,
                },
                [IDesignProjectId.TiledFloorBedRoom]: {
                    value : undefined,
                    min   : 0,
                    max   : 100,
                },
                [IDesignProjectId.WaxedConcreteFloorBedRoom]: {
                    value : undefined,
                    min   : 0,
                    max   : 100,
                },
                [IDesignProjectId.ParquetFloorBedRoom]: {
                    value : undefined,
                    min   : 0,
                    max   : 100,
                },
            },
            [IDesignProjectCategoryId.OfficeWorkSpace]: {
                [IDesignProjectId.Desk]: {
                    value : undefined,
                    min   : 0,
                    max   : 5,
                },
                [IDesignProjectId.Chair]: {
                    value : undefined,
                    min   : 0,
                    max   : 5,
                },
                [IDesignProjectId.Armchair]: {
                    value : undefined,
                    min   : 0,
                    max   : 5,
                },
                [IDesignProjectId.Library]: {
                    value : undefined,
                    min   : 0,
                    max   : 5,
                },
                [IDesignProjectId.Cupboard]: {
                    value : undefined,
                    min   : 0,
                    max   : 5,
                },
                [IDesignProjectId.WoodenWardrobe]: {
                    value : undefined,
                    min   : 0,
                    max   : 5,
                },
                [IDesignProjectId.MetalicWardrobe]: {
                    value : undefined,
                    min   : 0,
                    max   : 5,
                },
                [IDesignProjectId.MobileBoxes]: {
                    value : undefined,
                    min   : 0,
                    max   : 5,
                },
            },
        },
        additionalData: additionalDataFactory({
            budgetMin          : 2000,
            budgetMax          : 50000,
            budgetDefaultValue : 15000,
            marks              : budgetMarksBuilder(2000, 1000, 50000, 5000, 50000),
            hasQuantity        : false,
        }),
        contact: fieldsContact,
    },
};

export default dpHouseInteriorForm;
